import React, { useState } from 'react'
import { Heart } from 'lucide-react'
import { useWishlist } from '../context/wishlist-context'

interface WishlistButtonProps {
  productId: string
  size?: number
  className?: string
  showToast?: boolean
}

export const WishlistButton: React.FC<WishlistButtonProps> = ({
  productId,
  size = 24,
  className = '',
  showToast = true,
}) => {
  const { isInWishlist, toggleItem, loading } = useWishlist()
  const [isProcessing, setIsProcessing] = useState(false)
  const inWishlist = isInWishlist(productId)

  const handleClick = async (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()

    if (isProcessing || loading) return

    setIsProcessing(true)
    const success = await toggleItem(productId)
    setIsProcessing(false)

    if (showToast && success) {
      // You can integrate with a toast notification system here
      console.log(
        inWishlist
          ? 'محصول از علاقه‌مندی‌ها حذف شد'
          : 'محصول به علاقه‌مندی‌ها اضافه شد',
      )
    }
  }

  return (
    <button
      onClick={handleClick}
      disabled={isProcessing || loading}
      className={`transition-all duration-200 hover:scale-110 focus:outline-none ${className}`}
      aria-label={
        inWishlist ? 'حذف از علاقه‌مندی‌ها' : 'افزودن به علاقه‌مندی‌ها'
      }
      title={inWishlist ? 'حذف از علاقه‌مندی‌ها' : 'افزودن به علاقه‌مندی‌ها'}
    >
      <Heart
        size={size}
        fill={inWishlist ? 'currentColor' : 'none'}
        className={`transition-colors duration-200 ${
          inWishlist
            ? 'text-red-500'
            : 'text-gray-400 hover:text-red-500'
        } ${isProcessing || loading ? 'opacity-50' : ''}`}
        strokeWidth={2}
      />
    </button>
  )
}

